import React from 'react';

function Footer() {

    return (
        <footer className='footer'>
            <div>
                <a href="https://www.instagram.com/balaban.ivan/"
                    target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-instagram"></i>
                </a>
            </div>
            <p>Follow us on Instagram!</p>
        </footer>
    );
}

export default Footer;
